import ACTION_TYPES from '../../store/actionTypes.constants';

export const clearFilters = () => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPES.APPLIED_FILTERS,
      payload: {},
    });
  };
};
